import React from 'react';
import { FictionalIcon } from '../../customFrontend/parts';
import { ChatappTopic } from '../../siteBrands/chatapp/types';

/**
 * The topic pages' copy (manifest `type` `topic`), standard Dutch with
 * informal "je". Written for chatapp.nl, not translated from another site.
 */
export const TOPICS: Record<string, ChatappTopic> = {
  '/rijpe-vrouwen': {
    path: '/rijpe-vrouwen',
    slug: 'mature',
    name: 'Rijpe vrouwen',
    kicker: 'Flirten met ervaring, 40+',
    h1: 'Sexchat met rijpe vrouwen',
    lead: 'Gratis aanmelden zonder creditcard, je eerste berichten gratis en een zoekopdracht die begint bij 40 jaar en ouder.',
    intro: (
      <p>
        Niet iedereen zoekt een flirt met iemand van twintig. Op Chatapp.nl kun je ook chatten met rijpe vrouwen:
        profielen van vrouwen van veertig, vijftig en ouder die weten wat ze leuk vinden en dat ook gewoon zeggen.
        Noem het milf chat of noem het chatten met oudere vrouwen; het begint hier zoals alles op Chatapp.nl, met
        een gratis profiel en gratis eerste berichten.
      </p>
    ),
    sections: [
      {
        title: 'Waarom een gesprek met een rijpe vrouw anders loopt',
        body: (
          <>
            <p>
              Een vrouw met wat meer levenservaring hoeft niet te raden wat je bedoelt. Ze stelt een directe vraag,
              lacht om je grap als die goed is en laat merken wanneer hij dat niet is. Dat is voor veel mensen
              juist de charme van sexchat met rijpe vrouwen: minder spelletjes, meer zelfvertrouwen en een flirt
              die je echt moet verdienen.
            </p>
            <p>
              Dat spreekt heel verschillende mannen aan. Jongere mannen houden vaak van een vrouw die weet wat ze
              wil en daar niet omheen draait. Mannen van dezelfde leeftijd vinden het prettig als in het gesprek
              dezelfde muziek, dezelfde tv-series en dezelfde zaterdagavonden van vroeger terugkomen. Iedereen van
              18 jaar en ouder is welkom.
            </p>
          </>
        ),
      },
      {
        title: 'Milf chat, rijpe vrouwen of oudere vrouwen?',
        body: (
          <>
            <p>
              Wie online zoekt naar een chat met oudere vrouwen, komt steeds dezelfde woorden tegen. Milf is het
              meest direct, rijp klinkt wat eleganter en oudere vrouwen zegt gewoon waar het om gaat. Op
              Chatapp.nl leiden ze allemaal naar dezelfde plek: profielen van vrouwen van 40 jaar en ouder die er
              zijn om te flirten, en een gesprek in het tempo dat jij prettig vindt.
            </p>
            <p>
              Meld je je via deze pagina aan, dan staat je zoekopdracht meteen op 40 jaar en ouder. Zo passen de
              eerste profielen die je ziet bij waarvoor je kwam. Met de leeftijdsschuif pas je dat later zelf aan,
              zo ruim of zo smal als je wilt.
            </p>
          </>
        ),
      },
      {
        title: 'Zo werkt chatten met rijpe vrouwen op Chatapp.nl',
        body: (
          <>
            <p>
              Aanmelden duurt ongeveer een minuut: je kiest een nickname, geeft aan met wie je wilt chatten en vult
              je e-mailadres in. Om een creditcard vragen we daarbij nooit. Je eerste berichten zijn gratis, of je
              nu op de bank in Maastricht zit of in de trein naar Leeuwarden, dus je kunt rustig een paar flirts
              sturen en kijken of deze chat bij je past.
            </p>
            <p>
              Zijn je gratis berichten op, dan kosten berichten, flirts en foto’s credits. Een pakket koop je alleen
              als je verder wilt, en op de prijzenpagina zie je vooraf wat alles kost. Chatapp.nl is entertainment:
              de profielen met een persoonsicoon zijn fictief, en het plezier zit in het gesprek zelf.
            </p>
          </>
        ),
      },
    ],
    faqTitle: 'Vragen over chatten met rijpe vrouwen',
    faq: [
      {
        q: 'Is chatten met rijpe vrouwen gratis?',
        a: <p>Aanmelden is gratis en je hebt er geen creditcard voor nodig. Ook je eerste berichten kosten niets. Daarna betaal je berichten, flirts en foto’s met credits, en je ziet elke prijs voordat je een pakket koopt.</p>,
      },
      {
        q: 'Kan ik de leeftijd in de zoekopdracht later nog aanpassen?',
        a: <p>Ja. Via deze pagina begint je zoekopdracht bij 40 jaar en ouder, maar je verschuift de leeftijd op elk moment zelf, naar boven of naar beneden.</p>,
      },
      {
        q: 'Zijn de profielen van rijpe vrouwen echt?',
        a: (
          <p>
            Nee. Chatapp.nl gebruikt fictieve profielen die als doel hebben om met gebruikers te flirten. Je herkent
            ze aan het persoonsicoon <FictionalIcon language="nl" /> op hun profiel, en fysiek contact met deze
            profielen is niet mogelijk. Chatten met rijpe vrouwen is hier bedoeld als entertainment, niet om
            afspraken te maken.
          </p>
        ),
      },
      {
        q: 'Ziet iemand dat ik hier chat?',
        a: <p>Nee, tenzij je het zelf vertelt. Andere leden zien alleen je nickname, nooit je naam of e-mailadres, en er verschijnt niets op je sociale media.</p>,
      },
    ],
    cta: {
      title: 'Zin in een flirt met wat meer ervaring?',
      text: 'Maak gratis een profiel aan, stuur je eerste berichten zonder te betalen en begin bij profielen van 40 jaar en ouder.',
      button: 'Gratis chatten',
    },
    citiesTitle: 'Ook chatten in je eigen stad',
    link: {
      title: 'Liever een flirt met een rijpe vrouw?',
      text: 'Sexchat en milf chat met profielen van vrouwen van 40 jaar en ouder.',
      anchor: 'Sexchat met rijpe vrouwen',
    },
  },
};
